import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Recent.css'; 

const Popular = () => {
  const [popularMovies, setPopularMovies] = useState([]); // State to store popular movies

  // Fetch popular movies from the API
  useEffect(() => {
    const fetchPopularMovies = async () => {
      const apiKey = process.env.REACT_APP_TMDB_API_KEY; // Fetch the TMDB API key from environment variables
      try {
        // Fetch popular movies from the TMDB API
        const response = await fetch(
          `https://api.themoviedb.org/3/movie/popular?api_key=${apiKey}&language=en-US&page=1`
        );
        const data = await response.json(); // Parse the JSON response

        // Ensure that we get exactly 24 popular movies
        if (data.results.length >= 24) {
          setPopularMovies(data.results.slice(0, 24)); // Set state with the first 24 movies
        } else {
          setPopularMovies(data.results); // Set state with all available movies if less than 24
        }
      } catch (error) {
        console.error('Error fetching popular movies:', error); // Log any errors that occur during the fetch
      }
    };

    fetchPopularMovies(); // Call the fetch function
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  return (
    <div className="recent-movies-container">
      <h2 className="recent-movies-heading">Popular Movies</h2>
      <div className="movie-grid">
        {/* Map through the popularMovies state and display each movie */}
        {popularMovies.map((movie) => (
          <div key={movie.id} className="movie-item movie-title">
            <Link to={`/movies/${movie.id}`} className="movie-link">
              <img
                src={`https://image.tmdb.org/t/p/w300${movie.poster_path}`} // Movie poster URL
                alt={movie.title} // Alt text for accessibility
                className="movie-poster"
              />
              <div className="movie-title">{movie.title}</div> {/* Display movie title */}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popular;
